import script from "./EditIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditIcon.vue?vue&type=script&setup=true&lang=ts"

import "./EditIcon.vue?vue&type=style&index=0&id=030f8542&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-030f8542"]])

export default __exports__